import axios from "axios";

export const uploadAttachment = async (file, tireReportId, type, label) => {
  const data = new FormData();
  data.append('attachment', file.file);
  data.append('tireReportId', tireReportId);
  data.append('type', type);
  data.append('doctype', label);
  const config = {
    withCredentials: true,
    onUploadProgress: function (progressEvent) {
      file.progress.current = Math.round((progressEvent.loaded * 100) / progressEvent.total)
    }
  }
  try {
    const response = await axios.post(window.envConfig.API_BASEURL + '/api/attachments', data, config);
    file.progress.uploading = false
    file.progress.error = false
    file.progress.id = response.data
    return response.data
  }
  catch (error) {
    file.progress.uploading = false
    file.progress.error = error.toString()
    console.log("error", error)
    return null
  }
}

export const startNewTireReport = async (registrationNumber) => {
  return (await axios.get(window.envConfig.API_BASEURL + '/api/tire-reports/new?regnr=' + registrationNumber, { withCredentials: true })).data
}

export const getWorkshops = async () => {
  const data = (await axios.get(window.envConfig.API_BASEURL + '/api/workshops', { withCredentials: true })).data
  return data.workshops ? data.workshops : []
}

export const submitNewTireReport = async (assetId, newTireReport) => {
  return (await axios.post(window.envConfig.API_BASEURL + '/api/tire-reports/' + assetId, newTireReport, { withCredentials: true })).data
}

export const getAssetTireReports = async (assetId) => {
  return (await axios.get(window.envConfig.API_BASEURL + '/api/tire-reports/' + assetId, { withCredentials: true })).data
}
